import { centerMap, removeMapLayer } from "./mapFunctions";
import { searchQuery } from "./searchFunctions";
export { checkInputFields } from "./validators/searchValidators.js";

// Konstanten für Vitalitätsbilder und Vitalitätsbezeicnung
import imgVitalitaetGruen from "../img/icons/TreeClimategreen.png";
import imgVitalitaetGelb from "../img/icons/TreeClimateyellow.png";
import imgVitalitaetBrown from "../img/icons/TreeClimatebrown.png";
import imgVitalitaetRed from "../img/icons/TreeClimatered.png";
import imgVitalitaetGrey from "../img/icons/TreeClimategrey.png";

const stringVitalitaetGruen = "0 (Explorationsphase)";
const stringVitalitaetGelb = "1 (Degenerationsphase)";
const stringVitalitaetBrown = "2 (Stagnationsphase)";
const stringVitalitaetRed = "3 (Resignationsphase)";
const stringVitalitaetGrey = "";


/**
 * Funktion zum leeren eines DIV-Containers
 *
 * @export
 * @param {*} elementID Elemt das geleert werden soll
 */
export function clearDiv(elementID) {
  if (elementID != null) {
    document.getElementById(elementID).innerHTML = "";
  }
}

/**
 * Generiert eine Warning Message um den User zu Informieren
 *
 * @export
 * @param {*} headerText Überschrift der Warnmeldung
 * @param {*} contentText Text der Warnmeldung
 * @todo Anpassen der Warnstufe und ggf der Farbe
 */
export function warningMessage(headerText, contentText) {
  // Variablen
  let warningElement = document.getElementById("Warning-Element");
  let warningHeaderElement = document.getElementById("Warning-Header-Text");
  let warningContentElement = document.getElementById("Warning-Content-Text");
  let warningDisplayTime = 3000;

  // Container anzeigen und Texte einsetzen
  warningElement.classList.remove("d-none");
  warningHeaderElement.innerHTML = headerText;
  warningContentElement.innerHTML = contentText;

  /**
   * Schließt die Warning Message nach einer Gewissen zeit
   *
   * @param {*} warningElement Referenz zum Container der die Warnmeldung erhält
   */
  function closeWarningElement() {
    warningElement.style.display = "none";
    warningElement.classList.add("d-none");
  }

  // Timeout setzen
  setTimeout(closeWarningElement, warningDisplayTime);
}

/**
 * Erzeugt einen Link mit einem Listener
 *
 * @export
 * @param {*} innerHTMLText
 * @param {*} long
 * @param {*} lat
 */
export function createCenterMapLink(innerHTMLText, long, lat) {
  let link = document.createElement("a");
  link.setAttribute("class", "link-success text-decoration-none");
  let treeZoom = 20;

  link.innerHTML = innerHTMLText + " " + long + " " + lat;
  link.setAttribute("href", "#");

  //Eventlistener erstellen und hinzufügen
  let listener = {
    name: "foo",
    handleEvent: function (event) {
      centerMap(long, lat, treeZoom);
    },
  };

  link.addEventListener("click", listener);

  // Return HTMl Element
  return link;
}

/**
 * Gibt den Pfad des Vitaluitätsicons aus
 *
 * @param {String der die Vitalität des Baumes enthält} vitalityString
 * @returns
 */
export function getTreeVitalityIcon(vitalityString) {
  if (vitalityString == stringVitalitaetGruen) return imgVitalitaetGruen;
  else if (vitalityString == stringVitalitaetGelb) return imgVitalitaetGelb;
  else if (vitalityString == stringVitalitaetBrown) return imgVitalitaetBrown;
  else if (vitalityString == stringVitalitaetRed) return imgVitalitaetRed;
  else return imgVitalitaetGrey;
}

export function showLoading(activate) {
  const mapDimmerDiv = document.getElementById("mapDimmer");
  if (activate) {
    mapDimmerDiv.style.zIndex = "9999";
    mapDimmerDiv.style.opacity = "0.8";
  } else if (!activate) {
    mapDimmerDiv.style.opacity = "0";
    mapDimmerDiv.style.zIndex = "0";
  }
}
